import { useQuery } from "@tanstack/react-query";
import {
  JobTaskDetailSchema,
  mvpApiGetNextPendingJobTask,
} from "@augmodo/lebron-browser-client";

/**
 * React Query hook to fetch the next pending task for a given job
 */
export function useNextPendingTask(
  jobId: string | undefined,
  enabled: boolean = true,
) {
  return useQuery({
    queryKey: ["nextPendingTask", jobId],
    queryFn: async (): Promise<JobTaskDetailSchema> => {
      const response = await mvpApiGetNextPendingJobTask({
        path: {
          job_id: jobId || "",
        },
      });

      if (response.error) {
        throw new Error(`Failed to fetch next pending task: ${response.error}`);
      }

      return response.data as JobTaskDetailSchema;
    },
    enabled: !!jobId && enabled,
  });
}
